import { OrgConfigurationKey, useOrgConfiguration } from '../providers';
import { useFeatureFlag } from './useFeatureFlag';

/**
 * Returns market names configured to be hidden from restricted-trading Market Data selectors.
 * The list only applies when both `ui.EnableRestrictedTrading` and `ui.EnableAccountSegregation` are enabled.
 */
export function useRestrictedTradingHiddenMarkets(): string[] | undefined {
  const { enableAccountSegregationWithRestrictedTrading } = useFeatureFlag();
  const { getJSONArrayConfig } = useOrgConfiguration();
  const hiddenMarkets = getJSONArrayConfig<string>(OrgConfigurationKey.RestrictedTradingHiddenMarkets);

  if (!enableAccountSegregationWithRestrictedTrading || !hiddenMarkets?.length) {
    return undefined;
  }

  return hiddenMarkets;
}
